var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"o-primary-btn",class:_vm.classObject},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }